import request from '@/utils/request'

// 获取轮播图数据
export function getSwiperList() {
  return request({
    url: '/web/page/banner', // 使用代理路径
    method: 'get'
  })
    .then((response) => {
      console.log('API request successful:', response) // 打印API请求成功的响应
      return response // 返回整个response对象
    })
    .catch((error) => {
      console.error('API request failed:', error) // 打印API请求失败的错误
      throw error
    })
}

// 获取首页基础信息数据
export function getFooterData() {
  return request({
    url: '/web/page/index', // 使用代理路径
    method: 'get'
  })
    .then((response) => {
      console.log('API request successful:', response) // 打印API请求成功的响应
      return response // 返回整个response对象
    })
    .catch((error) => {
      console.error('API request failed:', error) // 打印API请求失败的错误
      throw error
    })
}

// 获取验证码
export function getCaptchaImage() {
  return request({
    url: '/web/captchaImage', // 使用代理路径
    method: 'get'
  })
    .then((response) => {
      console.log('API request successful:', response) // 打印API请求成功的响应
      return response // 返回整个response对象
    })
    .catch((error) => {
      console.error('API request failed:', error) // 打印API请求失败的错误
      throw error
    })
}

// 加盟申请
export function addBusiness(data) {
  return request({
    url: '/web/feedBack',
    method: 'post',
    data
  })
    .then((response) => {
      console.log('API request successful:', response) // 打印API请求成功的响应
      return response // 返回整个response对象
    })
    .catch((msg) => {
      console.error('API request failed:', msg) // 打印API请求失败的错误
      throw error
    })
}

// 获取产品分类
export function getProductCategories() {
  return request({
    url: '/web/goodsCate/list',
    method: 'get'
  })
    .then((response) => {
      console.log('API request successful:', response) // 打印API请求成功的响应
      return response // 返回整个response对象
    })
    .catch((error) => {
      console.error('API request failed:', error) // 打印API请求失败的错误
      throw error
    })
}

// 获取所有商品
export function getAllProducts(query) {
  return request({
    url: '/web/goods/list',
    method: 'get',
    params: query
  })
    .then((response) => {
      console.log('API request successful:', response) // 打印API请求成功的响应
      return response // 返回整个response对象
    })
    .catch((error) => {
      console.error('API request failed:', error) // 打印API请求失败的错误
      throw error
    })
}

// 获取单个商品信息
export function getProductById(id) {
  return request({
    url: `/web/goods/${id}`, // 替换为你的后端接口路径
    method: 'get'
  })
    .then((response) => {
      console.log('API request successful:', response) // 打印API请求成功的响应
      return response // 返回整个response对象
    })
    .catch((error) => {
      console.error('API request failed:', error) // 打印API请求失败的错误
      throw error
    })
}

// 获取所有资讯
export function getAllArticle(query) {
  return request({
    url: '/web/article/list',
    method: 'get',
    params: query
  })
    .then((response) => {
      console.log('API request successful:', response) // 打印API请求成功的响应
      return response // 返回整个response对象
    })
    .catch((error) => {
      console.error('API request failed:', error) // 打印API请求失败的错误
      throw error
    })
}
// 获取单个资讯信息
export function getArticleById(id) {
  return request({
    url: `/web/article/${id}`, // 替换为你的后端接口路径
    method: 'get'
  })
    .then((response) => {
      console.log('API request successful:', response) // 打印API请求成功的响应
      return response // 返回整个response对象
    })
    .catch((error) => {
      console.error('API request failed:', error) // 打印API请求失败的错误
      throw error
    })
}
// 文件上传
export function uploadFile(data) {
  return request({
    url: '/v1/fileUpload/upload',
    method: 'post',
    data
  })
    .then((response) => {
      console.log('API request successful:', response) // 打印API请求成功的响应
      return response // 返回整个response对象
    })
    .catch((error) => {
      console.error('API request failed:', error) // 打印API请求失败的错误
      throw error
    })
}
